/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf
 */
export interface SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf {
    /**
     * 
     * @type {string}
     * @memberof SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf
     */
    form_instance_link?: string;
}

/**
 * Check if a given object implements the SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf interface.
 */
export function instanceOfSupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOfFromJSON(json: any): SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf {
    return SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOfFromJSONTyped(json, false);
}

export function SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_instance_link': !exists(json, 'form_instance_link') ? undefined : json['form_instance_link'],
    };
}

export function SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOfToJSON(value?: SupplementalCreateFormInstanceResponseAllOfFormInstanceAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_instance_link': value.form_instance_link,
    };
}

